export default "__VITE_ASSET__DnYJB5f___"